export default function Hero() {
  const stats = [
    { value: "5", label: "类入口概念" },
    { value: "8", label: "常见栏目" },
    { value: "1", label: "页面闭环浏览" },
  ];

  return (
    <section id="top" className="relative pt-24 md:pt-28 pb-14 md:pb-20 bg-background-50 overflow-hidden">
      <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-primary-100/50 blur-3xl" />
      <div className="absolute top-40 -left-20 w-64 h-64 rounded-full bg-accent-100/40 blur-3xl" />

      <div className="relative mx-auto max-w-content px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="fade-up">
            <span className="inline-flex items-center gap-2 px-3.5 py-1.5 text-xs font-label rounded-full bg-primary-100 text-primary-800 border border-primary-200">
              <i className="ri-compass-3-line" />
              平台入口 · 地址说明 · 长期参考
            </span>

            <h1 className="mt-5 font-heading text-3xl md:text-4xl lg:text-5xl font-bold leading-tight text-foreground-950">
              大师兄影视地址导航
              <br />
              <span className="text-primary-700">找入口，先看这一页</span>
            </h1>

            <p className="mt-5 text-base leading-relaxed text-foreground-700 max-w-xl">
              这里集中说明大师兄影视的官网入口、最新地址、官方网址、发布页与永久入口分别指什么，
              并整理栏目概览与访问防走失的方法。所有内容在同一页面内形成闭环，方便你随时查找与核对，无需跳转其他页面。
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a
                href="#entries"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-label rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-door-open-line" />
                查看入口类型说明
              </a>
              <a
                href="#guide"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-label rounded-md bg-background-100 text-foreground-900 border border-background-300 hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-route-line" />
                访问与防走失指南
              </a>
            </div>

            <div className="mt-8 grid grid-cols-3 gap-4 max-w-md">
              {stats.map((s) => (
                <div key={s.label} className="border-l-2 border-accent-300 pl-3">
                  <div className="font-heading text-2xl font-bold text-foreground-950">{s.value}</div>
                  <div className="mt-1 text-xs text-foreground-600">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="fade-up">
            <div className="relative rounded-lg overflow-hidden border border-background-200 bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20scene%20with%20golden%20amber%20light%20rays%20streaming%20through%20a%20dark%20theater%2C%20soft%20bokeh%20particles%2C%20deep%20teal%20shadow%20tones%2C%20stylized%20artistic%20film%20atmosphere%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20moody%20premium%20aesthetic&width=900&height=720&seq=dsx-hero-2026&orientation=landscape"
                alt="暖金色光影构成的影视氛围插图，寓意平台入口与浏览体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/10 to-transparent" />
              <div className="absolute left-4 right-4 bottom-4 md:left-5 md:right-5 md:bottom-5 rounded-md bg-background-50/95 backdrop-blur px-4 py-3 border border-background-200">
                <div className="flex items-center gap-2 text-sm font-label text-foreground-950">
                  <i className="ri-shield-check-line text-accent-600" />
                  收藏本页，地址变化时仍能找到起点
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}